module.exports = __webpack_public_path__ + "img/icons_safari.e754754.png";